export default {
  'component.globalHeader.search': 'Buscar',
  'component.globalHeader.search.placeholder': '¿Qué necesitas hacer?',
  'component.globalHeader.help': 'Ayuda',
  'component.globalHeader.search.recent': 'Búsquedas recientes',
  'component.globalHeader.notification': 'Notificación',
  'component.globalHeader.notification.empty': 'Has visto todas las notificaciones.',
  'component.globalHeader.message': 'Mensaje',
  'component.globalHeader.message.empty': 'Has visto todas las notificaciones.',
  'component.globalHeader.event': 'Evento',
  'component.globalHeader.event.empty': 'Has visto todos los eventos.',
  'component.noticeIcon.clear': 'Limpiar',
  'component.noticeIcon.cleared': 'Limpio',
  'component.noticeIcon.empty': 'Sin notificaciones',
  'component.noticeIcon.view-more': 'Ver más',
};
